import { EColors } from "common/styles";
import styled from "styled-components";

export const StyledListProducts = styled.ul`
  list-style: none;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  z-index:1;
  
  &:after {
    position: absolute;
    top:-50%;
    left:55vw;
    display: block;
    content: "";
    width: 303px;
    height: 303px;
    border-radius:50%;
    background: #009846;
    opacity: 0.2;
    filter: blur(100px);
    z-index:-1;
  }
  @media screen and (max-width: 767px) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    &:after {
    position: absolute;
    top: 50%;
    left:0;
    display: block;
    content: "";
    width: 243px;
    height: 243px;
    border-radius:50%;
    background: #009846;
    opacity: 0.2;
    filter: blur(100px);
    z-index:-1;
  }
  }
`;
export const StyledItemProduct = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 136px;
  background-color: ${EColors.neutral_700};
  opacity: 0.8;
  position: relative;
  
  /* &:not(:last-child) { */
    border-right: 1px solid #a0ebc3;
    backdrop-filter: blur(5px);
  /* } */
  @media screen and (min-width: 768px) {
    width: 200px;
    height: 160px;
  }
`;
export const StyledItemProductName = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: transparent;
`;

export const IconEllipse = styled.svg<{
  fill: string;
}>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 56px;
  height: 68px;
  fill: ${(props) => props.fill};
  z-index: 2;
`;

export const StyledNameWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: 600;
  font-size: 24px;
  line-height: 132%;
  text-align: center;
  font-feature-settings: "case" on;
  color: ${EColors.neutral_700};
  z-index: 3;
  @media screen and (max-width: 767px) {
    font-size: 20px;
  }
`;

export const StyledItemProductPrice = styled.p`
  font-weight: 700;
  font-size: 36px;
  line-height: 132%;
  font-feature-settings: "case" on;
  color: ${EColors.white};
  @media screen and (max-width: 767px) {
    font-size: 24px;
  }
`;

export const StyledSpan = styled.span`
  font-size: 22px;
  vertical-align: super;
  margin-left: 8px;
  @media screen and (max-width: 767px) {
    font-size: 16px;
  }
`;
